class POVItem {
  constructor(contentfulNode) {
    this.id = contentfulNode?.id;
    this.title = contentfulNode?.title;
    this.titleIcon = contentfulNode?.titleIcon;
    this.content = contentfulNode?.content;
    this.stat = contentfulNode?.stat;
    this.statContent = contentfulNode?.statContent;
    this.linkText = contentfulNode?.linkText;
    this.link = contentfulNode?.link;
    this.image = {
      data: contentfulNode?.image?.gatsbyImageData,
      title: contentfulNode?.image?.title
    };
  }
}

export default POVItem;
